
var Core = (function () {
    var _fetchAsync = async (url, caption, body = null) => {
        let jb = {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };

        if (body !== null) {
            let sendJSON = JSON.stringify(body);
            jb.body = "{inputsParam:'" + sendJSON + "'}";

        }
        const promise = await fetch(url + caption, jb);
        return await promise.json();
    };

    var _replaceBrackets = str => {
        let end = str.indexOf(')') + 1,
            lenth_ = str.length,
            rezult = str;
        if (end !== -1)
            rezult = str.slice(end, lenth_);
        return rezult;
    };

    var _replaceBracketsArr = (str, ch) => {
        let arr_ = str.split(ch),
            rezult = '';
        arr_.forEach((value) => {
            rezult += (ch + ' ' + _replaceBrackets(value));
        })
        return rezult.substr(1);
    };

    return {
        fetchAsync: _fetchAsync,
        replaceBrackets: _replaceBrackets,
        replaceBracketsArr: _replaceBracketsArr
    }
})();

var About = (function () {
    const URL = './ASPWebDataServise.asmx/';

    var _fetchAsync = async (url, caption, body = null) => {
        let jb = {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };

        if (body !== null) {
            let sendJSON = JSON.stringify(body);
            jb.body = "{inputsParam:'" + sendJSON + "'}";

        }
        const promise = await fetch(url + caption, jb);
        return await promise.json();
    };

    var _setContacts = response => {
        let a = JSON.parse(response.d);
        if ($.isEmptyObject(a) || a.HasError) {
            $('.list-contact').append('<div class="text-center m-5">Информация не найдена </div>');
            return false;
            //To DO:
        }

        $('.list-contact').html('');
        let item = a.Result;
        let txt = ` <div class="item-contact mt-4 ml-5">
                            <h5>${item.organization}</h5>
                            <div class="m-4">
                                <p class="item-contact-row"><span class="glyphicon glyphicon-map-marker" aria-hidden="true"></span> ${item.address}</p>
                                ${item.phone ? `<p class="item-contact-row"><span class="glyphicon glyphicon-phone-alt" aria-hidden="true"></span> ${item.phone}</p>` : ``}
                                ${item.email ? `<p class="item-contact-row"><span class="glyphicon glyphicon-envelope" aria-hidden="true"></span> ${item.email}</p>` : ``}
                                ${item.website ? `<p class="item-contact-row"><span class="glyphicon glyphicon-globe" aria-hidden="true"></span><a href="${item.website}" target="_blank" rel="noopener noreferrer"> ${item.website} </a></p>` : ``}
                            </div>
                        </div>`;
        $('.list-contact').append(txt);
    };


    var _setFeedback = response => {
        let a = JSON.parse(response.d);
        if ($.isEmptyObject(a) || a.HasError) {
            alert(a.ErrorMessage);
            return false;
        }
        else {
            let formArr = $('#mailForm').serializeArray();

            formArr.forEach((item) => {
                $(`input[name='${item.name}']`).val('');
            });
            $(`textarea[name='textMail']`).val('');
            alert(`Сообщение успешно отправлено`);
        }
    }

    // точка входа 
    var init = () => {
        let promise = _fetchAsync(URL, 'GetContactOrganization', {}).then(response => _setContacts(response), err => console.error(`ошибка при получении данных: ${err}`));
        return false;
    };

    var sendMail_ = (e) => {
        e.preventDefault();

        let formArr = $('#mailForm').serializeArray(),
            sendObj = {};

        formArr.forEach((item) => {
            if (item.value != '' && item.name != 'g-recaptcha-response')
                sendObj[item.name] = item.value;
        });
        //core.startLoadingAnimation();


        const CAPTCHA = grecaptcha.getResponse();

        if (CAPTCHA && Object.keys(sendObj).length == 4)
            _fetchAsync(URL, 'Feedback', sendObj).then(response => _setFeedback(response), err => console.error(`ошибка при получении данных: ${err}`));
        else
            alert(`Проверьте правильность ввода данных`);
    };

    return {
        // public методы
        init: init,
        SendMailClick: sendMail_
    };
}());

var Special = (function () {
    const URL = './ASPWebDataServise.asmx/';

    // #region методы смены шрифта и цветовой схемы
    var changeFonts = (event) => {
        $('.change-font').removeClass('checked');

        if ($(event.currentTarget).hasClass('btn-font-size-100')) {
            $('body').css('font-size', '1em');
            $(event.currentTarget).toggleClass('checked');
        }
        else
            if ($(event.currentTarget).hasClass('btn-font-size-150')) {
                $('body').css('font-size', '1.15em');
                $(event.currentTarget).toggleClass('checked');
            }
            else
                if ($(event.currentTarget).hasClass('btn-font-size-200')) {
                    $('body').css('font-size', '1.3em');
                    $(event.currentTarget).toggleClass('checked');
                }
    };

    var changeColors = (event) => {
        $('.change-color').removeClass('checked');
        $(event.currentTarget).toggleClass('checked');
        let theme = '';
        if ($(event.currentTarget).hasClass('btn-color-1')) {
            theme = 'spec-wb.css';
        }
        else
            if ($(event.currentTarget).hasClass('btn-color-2')) {
                theme = 'spec-bw.css';
            }
            else
                if ($(event.currentTarget).hasClass('btn-color-3')) {
                    theme = 'spec-bb.css';
                }
                else
                    if ($(event.currentTarget).hasClass('btn-color-4')) {
                        theme = 'spec-yg.css';
                    }
                    else
                        if ($(event.currentTarget).hasClass('btn-color-5')) {
                            theme = 'spec-bg.css';
                        }

        $('link[rel="stylesheet"]').each(function () {
            if (this.href.indexOf('spec-') >= 0) {
                let arr = this.href.split('/');

                this.href = './css/' + theme;
            }
        });
    };

    // #endregion

    // #region методы продвижения по списку поставщиков
    var listControlsForwardClick = () => {
        let maxNum = $('.btn-list-controls').data('maxNum');
        Core.fetchAsync(URL, 'GetListOrg', { PageNumber: (maxNum + 1) }).then(response => _setReestrPost(response), error => console.error('ошибка при получении данных реестра поставщиков'));
    };

    var listControlsBackClick = () => {
        let maxNum = $('.btn-list-controls').data('maxNum');
        Core.fetchAsync(URL, 'GetListOrg', { PageNumber: (maxNum - 1) }).then(response => _setReestrPost(response), error => console.error('ошибка при получении данных реестра поставщиков'));
    };

    // #endregion

    // список поставщиков
    var _setReestrPost = (response) => {

        let a = JSON.parse(response.d);
        if ($.isEmptyObject(a)) {
            return false;
            //To DO:
        }
        const LISTORG = a.listOrg,
            LISTCOUNT = a.count;

        $('.organization-container').html('');
        $('.grid-container').fadeIn(200);

        LISTORG.forEach((item) => {
            let txt = `<div class="organization-item card-body">
            <h5 class="organization-item__title">${item.name}</h5>
            <p class="organization-item__text">${item.addr}</p>
            <p class="organization-item__text">${item.tel}</p>
            <p class="organization-item__text">${item.email}</p>
            <div class="d-flex justify-content-end">
                <div><a href="?id=${item.id}" class="organization-item__link">Паспорт организации</a><div></div></div>
            </div>
        </div>`;
            $('.organization-container').append(txt);
        });

        let Arr = LISTORG.map((item) => {
            return parseInt(item.num);
        }),
            maxElem = Math.max(...Arr),
            maxNum = Math.floor(maxElem / 10);

        $('.btn-list-controls').data('maxNum', maxNum);

        if (maxElem >= LISTCOUNT)
            $('.btn-list-controls__forward').hide();
        else {
            if (maxElem == 10)
                $('.btn-list-controls__back').hide();
            else
                $('.btn-list-controls__back').show();
            $('.btn-list-controls__forward').show();
        }
    };

    // #region Витрина услуг 
    // список груп услуг
    var _setShowGroupServices = (response) => {
        let a = JSON.parse(response.d);
        if ($.isEmptyObject(a)) {
            return false;
            //To DO:
        }

        const LISTGROUP = a;
        $('.service-group-container').html('');
        $('.showcase-services-container').fadeIn(200);
        LISTGROUP.forEach((item) => {
            let txt = `<div class="service-group p-0 mb-4">
                           <div class="cards " id="${item.id}">
                               <div class="card-body">
                                   <div class="d-flex flex-row justify-content-between mb-3">
                                       <div> <h5 class="service-group__title cards-title">${item.nkod}</h5></div>
                                       <div> <a class="service-group__badge" title="Всего организаций по данной категории">${(item.countService ? item.countService : item.countservice)}</a></div>
                                   </div>
                                   <div class="collapse" id="collap_${item.id}"></div>
                                   <a href="#" class="service-group__link" id="btn-${item.id}">список услуг</a>
                               </div>
                           </div>
                       </div>`;
            $('.service-group-container').append(txt);
        });
    };

    // список услуг по группе
    var _setListUslFromSelectServiceGroup = (response) => {
        let a = JSON.parse(response.d);
        if ($.isEmptyObject(a)) {
            return false;
            //To DO:
        }

        let indexGroup = a.description,
            listServices = a.info;
        $(`#collap_${indexGroup}`).html('');
        $(`#collap_${indexGroup}`).append(`<ul class="service-group__list-services" id="collapse-services_${indexGroup}">`);
        listServices.forEach((item) => {
            let txt = `<li>${item.nkod}</li>`;
            $(`#collapse-services_${indexGroup}`).append(txt);
        });
        $(`#collap_${indexGroup}`).append('</ul>');
        $(`#collap_${indexGroup}`).show();

    };

    //клик по списку услуг из витрины 
    var serviceGroupItemClick = (e) => {
        let idInfo = e.currentTarget.id,
            idArr = idInfo.split('-');
        if (idArr.length < 2)
            return false;

        let id = idArr[1];

        if (!$(`#collap_${id}`).is(':visible')) {

            if (!$(`#collapse-services_${id}`).length > 0)
                Core.fetchAsync(URL, 'GetListUslFromVidUsl', { s_uslId: id }).then(response => _setListUslFromSelectServiceGroup(response), error => console.error('ошибка при получении списка услуг'));
            else
                $(`#collap_${id}`).show();
            $(`#btn-${id}`).text('свернуть список услуг');
        }
        else {
            $(`#collap_${id}`).hide();
            $(`#btn-${id}`).text('список услуг');
        }
    };

    //#endregion

    // #region Пасспорт организации
    // основная информация
    var _setBasicInfoFromPassport = (response) => {
        let a = JSON.parse(response.d);
        if ($.isEmptyObject(a)) {
            return false;
            //To DO:
        }
        $.each(a, (key, value) => {
            if (value != '') {
                if (key === 'isauthorized' && value == 0) {
                    $(`#${key}`).text('Нет не является');
                }
                else if (key === 'isauthorized' && value == 1) {
                    $(`#${key}`).text('Да является');
                }
                else {
                    if (key == 'website' && value)
                        $(`#${key}`).attr('href', value);

                    $(`#${key}`).text(value);
                }
            }
            else
                $(`#row_${key}`).hide();
        });
    };

    //структурные подразделения 
    var _setDivisionsInfoFromPassport = response => {
        let a = JSON.parse(response.d);
        if ($.isEmptyObject(a)) {
            $('.passport-section__divisions').hide();
            return false;
        }
        $('.divisions-container').html('');
        a.forEach(item => {
            let txt = `<div class="divisions-item mt-4 ml-4" id="di_${item.id}">
                            <h5 class="divisions-item__caption">${item.caption}</h5>
                            <p class="divisions-item__address"> ${item.addr}</p>
                       </div>`;
            $('.divisions-container').append(txt);
        });
        $('.passport-section__divisions').show();
    };

    //формы социального обслуживания
    var _setFormInfoFromPassport = response => {
        let a = JSON.parse(response.d);
        if ($.isEmptyObject(a)) {
            $('.passport-section__forms').hide();
            return false;
        }
        $('.passport-section__forms').show();
        $('.forms-container').html('');

        a.forEach(item => {
            let txt = `<div class="forms-item mt-4 ml-4">
                            <h5 class="forms-item__caption">${Core.replaceBrackets(item.caption)}</h5>
                            <ul class ="forms-item__list">`;
            const TYPE = item.value;
            TYPE.forEach(itemType => {
                txt += `<li>${itemType.v}</li>`;
            });
            txt += `</ul></div>`;

            $('.forms-container').append(txt);
        });
    };

    //лицензии
    var _setLicenseInfoFromPassport = response => {
        let a = JSON.parse(response.d);
        if ($.isEmptyObject(a)) {
            $('.passport-section__license').hide();
            return false;
        }
        $('.passport-section__license').show();
        $('.license-container').html('');
        a.forEach(item => {
            let txt = `<div class ="container mt-4 ml-4">
                        <dl class="row">
                        <dt class="col-xs-12 col-sm-4">${item.name}</dt>
                        <dd class="col-xs-12 col-sm-8">${item.seria} ${item.nomer} от ${item.datd}, действует от ${item.sroks} ${item.sved}</dd>

                        <dt class="col-xs-12 col-sm-4">Организация, выдавшая лицензию</dt>
                        <dd class="col-xs-12 col-sm-8">${item.org}</dd>`;
            if (item.imageid) {
                txt += `<dt class="col-xs-12 col-sm-4">Файл</dt>
                        <dd class="col-xs-12 col-sm-8"><a href="./img.ashx?id=${item.imageid}"> ${item.imagename} (Скачать)</dd> `;
            }

            txt += `</dl></div>`;
            $('.license-container').append(txt);
        });
    };

    //свободные места
    var _setFreePlaceInfoFromPassport = response => {
        let a = JSON.parse(response.d);
        if ($.isEmptyObject(a)) {
            $('.passport-section__free-places').hide();
            return false;
        }

        $('.passport-section__free-places').show();
        $('.free-places-container').html('');
        a.forEach((item) => {
            let txt = `<div class="free-places-item mt-3 ml-5 pb-3">
                <dl class="row free-places-item__row">
                    <dt class="col-12 col-sm-3">Наименование</dt>
                    <dd class="col-12 col-sm-9">${item.nkod}</dd>
                </dl>
                <dl class="row free-places-item__row">
                    <dt class="col-12 col-sm-3">Тип подразделения</dt>
                    <dd class="col-12 col-sm-9">${item.tip_name}</dd>
                </dl>
                <dl class="row free-places-item__row">
                    <dt class="col-sm-3">Адрес</dt>
                    <dd class="col-sm-9">${item.fra_addr}</dd>
                </dl> 
                <dl class="row free-places-item__row">
                    <dt class="col-sm-3">Форма обслуживания</dt>
                    <dd class="col-sm-9">${Core.replaceBracketsArr(item.formobsl.substr(2), ';')}</dd>
                </dl> 
                <dl class="row free-places-item__row">
                    <dt class="col-sm-3">Категория граждан</dt>
                    <dd class="col-sm-9">${item.naimgr}</dd>
                </dl>
                <dl class="row free-places-item__row">
                    <dt class="col-sm-3">Количество мест</dt>
                    <dd class="col-sm-9"> всего мест: ${item.kolmest_ob}  свободно: ${item.kolmest_sv}</dd>
                </dl>
        </div>`;
            $('.free-places-container').append(txt);
        })
    };

    //условия предоставления
    var _setProvisionServicesInfoFromPassport = response => {
        let a = JSON.parse(response.d);
        if ($.isEmptyObject(a)) {
            $('.provision-services-container').html('<b>Условия бесплатного предоставление социальных услуг</b><br/>Социальные услуги в форме социального обслуживания на дому, в полустационарной и стационарной формах социального обслуживания предоставляются бесплатно: <br/>1) несовершеннолетним детям; <br/>    2) лицам, пострадавшим в результате чрезвычайных ситуаций, вооруженных межнациональных(межэтнических) конфликтов.<br/>        Социальные услуги в форме социального обслуживания на дому и в полустационарной форме социального обслуживания предоставляются бесплатно, если на дату обращения среднедушевой доход получателя социальных услуг, рассчитанный в соответствии с нормативными правовыми актами Российской Федерации, ниже предельной величины или равен предельной величине среднедушевого дохода для предоставления социальных услуг бесплатно, установленной законом субъекта Российской Федерации.<br/>            Нормативными правовыми актами субъектов Российской Федерации могут быть предусмотрены иные категории граждан, которым социальные услуги предоставляются бесплатно.<br/>                Порядок определения среднедушевого дохода для предоставления социальных услуг бесплатно для целей настоящего Федерального закона устанавливается Правительством Российской Федерации.<br/>                    Размер предельной величины среднедушевого дохода для предоставления социальных услуг бесплатно устанавливается законами субъекта Российской Федерации и не может быть ниже полуторной величины прожиточного минимума, установленного в субъекте Российской Федерации для основных социально - демографических групп населения.<br/>                        <br/>                        <br/>                        <b>Условия платного предоставление социальных услуг и определение размера платы</b> <br/>Социальные услуги в форме социального обслуживания на дому и в полустационарной форме социального обслуживания предоставляются за плату или частичную плату, если на дату обращения среднедушевой доход получателей социальных услуг, рассчитанный в соответствии с частью 4 статьи 31 настоящего Федерального закона, превышает предельную величину среднедушевого дохода, установленную частью 5 статьи 31 настоящего Федерального закона.<br/>        Размер ежемесячной платы за предоставление социальных услуг в форме социального обслуживания на дому и в полустационарной форме социального обслуживания рассчитывается на основе тарифов на социальные услуги, но не может превышать пятьдесят процентов разницы между величиной среднедушевого дохода получателя социальной услуги и предельной величиной среднедушевого дохода, установленной частью 5 статьи 31 настоящего Федерального закона.<br/>            Социальные услуги в стационарной форме социального обслуживания предоставляются их получателям за плату или частичную плату, за исключением получателей социальных услуг, указанных в частях 1 и 3 статьи 31 настоящего Федерального закона.<br/>                Размер ежемесячной платы за предоставление социальных услуг в стационарной форме социального обслуживания рассчитывается на основе тарифов на социальные услуги, но не может превышать семьдесят пять процентов среднедушевого дохода получателя социальных услуг, рассчитанного в соответствии с частью 4 статьи 31 настоящего Федерального закона.<br/>                    Плата за предоставление социальных услуг производится в соответствии с договором о предоставлении социальных услуг, предусмотренным статьей 17 настоящего Федерального закона.<br/><br/>	');
            return false;
        }
        $('.provision-services-container').html('');
        let txt = `<ul>`;
        a.forEach(item => {
            txt += `<li>${item.v}</li>`;
        });
        txt += `</ul>`;
        $('.provision-services-container').append(txt);
    };

    // проверки
    var _setChecksInfoFromPassport = response => {
        let a = JSON.parse(response.d);
        if ($.isEmptyObject(a)) {
            $('.check-caption').hide();
            $('.сhecks-container').hide();
            return false;
        }
        $('.check-caption').show();
        $('.сhecks-container').show();
        $('.сhecks-container').html('');
        a.forEach(item => {
            let txt = `<div class ="container mt-4 ml-4">
                        <dl class="row">
                        <dt class="col-xs-12 col-sm-4">Вид проверки</dt>
                        <dd class="col-xs-12 col-sm-8">${item.vid}</dd>

                        <dt class="col-xs-12 col-sm-4">Дата проверки</dt>
                        <dd class="col-xs-12 col-sm-8">${item.datprov}</dd>

                        <dt class="col-xs-12 col-sm-4">Организация проводившая проверку</dt>
                        <dd class="col-xs-12 col-sm-8">${item.s31}</dd>`;

            if (item.comment) {

                txt += `<dt class="col-xs-12 col-sm-4">Результаты</dt>
                        <dd class="col-xs-12 col-sm-8">${item.comment}</dd>`
            };

            if (item.filename) {

                txt += `<dt class="col-xs-12 col-sm-4">Файл</dt>
                    <dd class="col-xs-12 col-sm-8"><a target="_blank" href="./img.ashx?id=p${item.id}" rel="noopener noreferrer">${item.filename} (Скачать)</a></dd>`;
            };
            txt += `</dl></div>`;

            $('.сhecks-container').append(txt);
        });
    };

    // нарушения
    var _setViolationsInfoFromPassport = response => {
        let a = JSON.parse(response.d);
        if ($.isEmptyObject(a)) {
            $('.violations-caption').hide();
            $('.violations-container').hide();

            if (!$('.сhecks-container').is(':visible'))
                $('.passport-section__сhecks-violations').hide();
            return false;
        }

        //TO DO:
        $('.passport-section__сhecks-violations').show();
        $('.violations-container').html('');
    };

    // опыт работы
    var _setExperienceInfoFromPassport = response => {
        let a = JSON.parse(response.d);
        if ($.isEmptyObject(a)) {
            $('.passport-section__experience').hide();
            return false;
        }
        $('.passport-section__experience').show();
        $('.experience-container').html('');
        a.forEach(item => {
            let txt = `<div class ="container mt-4 ml-4">
                        <dl class="row">
                        <dt class="col-xs-12 col-sm-4">Наименование</dt>
                        <dd class="col-xs-12 col-sm-8">${item.s24}</dd>

                        <dt class="col-xs-12 col-sm-4">Информация</dt>
                        <dd class="col-xs-12 col-sm-8">№ ${item.nomer} от ${item.datd}, действует c ${item.sroks}</dd>

                        <dt class="col-xs-12 col-sm-4">Организация выдавшая документ</dt>
                        <dd class="col-xs-12 col-sm-8">${item.s31}</dd>`;

            if (item.filename) {

                txt += `<dt class="col-xs-12 col-sm-4">Файл</dt>
                    <dd class="col-xs-12 col-sm-8"><a target="_blank" href="./img.ashx?id=s${item.scanid}" rel="noopener noreferrer">${item.filename} (Скачать)</a></dd>`;
            };
            txt += `</dl></div>`;
            $('.experience-container').append(txt);
        })
    };

    // прочая информация
    var _setOtherInfoFromPassport = response => {
        let a = JSON.parse(response.d);
        if ($.isEmptyObject(a)) {
            $('.passport-section__other-info').hide();
            return false;
        }
        $('.passport-section__other-info').show();
        $('.d-info-containe').html('');

        let docInfo = a.docInfo,
            yInfo = a.yInfo;


        let txt = `<div class ="container mt-4 ml-4">
                        <dl class="row">
                        <dt class="col-xs-12 col-sm-4">ИНН</dt>
                        <dd class="col-xs-12 col-sm-8">${yInfo.inn}</dd>

                        <dt class="col-xs-12 col-sm-4">ОГРН</dt>
                        <dd class="col-xs-12 col-sm-8">${yInfo.ogrn}</dd>

                        <dt class="col-xs-12 col-sm-4">ОКАТО</dt>
                        <dd class="col-xs-12 col-sm-8">${yInfo.okato}</dd>

                        <dt class="col-xs-12 col-sm-4">ОКОГУ</dt>
                        <dd class="col-xs-12 col-sm-8">${yInfo.okogu}</dd>

                        <dt class="col-xs-12 col-sm-4">ОКПО</dt>
                        <dd class="col-xs-12 col-sm-8">${yInfo.okpo}</dd>

                        <dt class="col-xs-12 col-sm-4">ОКТМО</dt>
                        <dd class="col-xs-12 col-sm-8">${yInfo.oktmo}</dd>
                </dl></div>`;

        $('.y-info-container').html(txt);

        docInfo.forEach(item => {
            let txt = `<div class ="container mt-4 ml-4">
                        <dl class="row">
                        <dt class="col-xs-12 col-sm-4">Наименование</dt>
                        <dd class="col-xs-12 col-sm-8">${item.name ? item.docname : item.name}</dd>

                        <dt class="col-xs-12 col-sm-4">Информация о документе</dt>
                        <dd class="col-xs-12 col-sm-8">№ ${item.nomer} от ${item.datd}, действует c ${item.sroks}</dd>

                        <dt class="col-xs-12 col-sm-4">Организация выдавшая документ</dt>
                        <dd class="col-xs-12 col-sm-8">${item.orgname ? `нет данных` : item.orgname}</dd>`;

            if (item.filename) {

                txt += `<dt class="col-xs-12 col-sm-4">Файл</dt>
                    <dd class="col-xs-12 col-sm-8"><a target="_blank" href="./img.ashx?id=${item.scanid}" rel="noopener noreferrer">${item.filename} (Скачать)</a></dd>`;
            };
            txt += `</dl></div>`;
            $('.d-info-container').append(txt);
        })
    };

    // вход в пасспорт 
    var _setPassportInfo = id => {

        Core.fetchAsync(URL, 'GetBasicInfo', { orgId: id })
            .then(response => _setBasicInfoFromPassport(response), error => console.error('ошибка при получении данных витрины услуг'))

            .then(x => Core.fetchAsync(URL, 'GetStructUnitsInfo', { orgId: id }))
            .then(response => _setDivisionsInfoFromPassport(response), error => console.error(`error => не получены данные по подразделениям => ${error} `))

            .then(x => Core.fetchAsync(URL, 'GetFormsInfo', { orgId: id }))
            .then(response => _setFormInfoFromPassport(response), error => console.error(`error => не получены данные по Формам социального обслуживания => ${error} `))

            .then(x => Core.fetchAsync(URL, 'GetLicenseInfo', { orgId: id }))
            .then(response => _setLicenseInfoFromPassport(response), error => console.error(`error => не получены данные по лицензиям => ${error} `))

            .then(x => Core.fetchAsync(URL, 'GetFreePlaceInfo', { orgId: id }))
            .then(response => _setFreePlaceInfoFromPassport(response), error => console.error(`error => не получены данные по свободным местам => ${error} `))

            .then(x => Core.fetchAsync(URL, 'GetUslPred', { orgId: id }))
            .then(response => _setProvisionServicesInfoFromPassport(response), error => console.error(`error => не получены данные по Формам социального обслуживания => ${error} `))

            .then(x => Core.fetchAsync(URL, 'GetVerificationInfo', { orgId: id }))
            .then(response => _setChecksInfoFromPassport(response), error => console.error(`error => не получены данные по проверкам => ${error} `))

            .then(x => Core.fetchAsync(URL, 'GetViolationsInfo', { orgId: id }))
            .then(response => _setViolationsInfoFromPassport(response), error => console.error(`error => не получены данные по нарушениям => ${error} `))

            .then(x => Core.fetchAsync(URL, 'GetWorkInfo', { orgId: id }))
            .then(response => _setExperienceInfoFromPassport(response), error => console.error(`error => не получены данные по опыту работы => ${error} `))

            .then(x => Core.fetchAsync(URL, 'GetOtherInfo', { orgId: id }))
            .then(response => _setOtherInfoFromPassport(response), error => console.error(`error => не получены данные по прочей информации => ${error} `))

            .then(x => $('.load-content').hide());

        $('.passport-container').show();

    };

    // #endregion

    // точка входа 
    var init = () => {
        const SEARCH = location.search.replace('?', '').split('='),
            ACTION = SEARCH[0];

        // TO DO:
        $('.grid-container').hide();
        $('.showcase-services-container').hide();
        $('.passport-container').hide();
        $('.about-container').hide();
        $('.info-container').hide();
        switch (ACTION) {
            case 'reestr'://reestr
                Core.fetchAsync(URL, 'GetListOrg', {}).then(response => _setReestrPost(response), error => console.error('ошибка при получении данных реестра поставщиков'))
                    .then(x => $('.load-content').hide());
                break;
            case 'id': //id=123
                _setPassportInfo(SEARCH[1]);
                break;
            case 'showcase':
                Core.fetchAsync(URL, 'GetListVidUsl', {}).then(response => _setShowGroupServices(response), error => console.error('ошибка при получении данных витрины услуг'))
                    .then(x => $('.load-content').hide());
                break;
            case 'about':
                $('.about-container').fadeIn(200);
                About.init();
                $('.load-content').hide();
                break;
            default:
                $('.info-container').fadeIn(200);
                $('.load-content').hide();
                break;
        }
    };

    return {
        // public методы
        init: init,
        changeFonts: changeFonts,
        changeColors: changeColors,
        listControlsForwardClick: listControlsForwardClick,
        listControlsBackClick: listControlsBackClick,
        serviceGroupItemClick: serviceGroupItemClick
    };
}());


(function main() {
    $("body").fadeIn(2000);

    // обработчики событий
    $('.change-font').on('click', Special.changeFonts);
    $('.change-color').on('click', Special.changeColors);
    $('.btn-list-controls__forward').on('click', Special.listControlsForwardClick);
    $('.btn-list-controls__back').on('click', Special.listControlsBackClick);
    $('.service-group-container').on('click', '.service-group__link', Special.serviceGroupItemClick);
    $("#target").on('click', About.SendMailClick);
    Special.init();
}());